module.exports = __webpack_public_path__ + "img/block-r-1.45a0b863.jpg";